export const theme = {
    body:"#202020",
    grey:'rgba(189, 189, 189, 0.77)',


    fontxs: '0.75em',
    fontsm: '1em',
    fontmd: '1.5em',
    fontlg: '2em',
    fontlgB: '2.5em',
    fontxl: '3.5em',
    fontxlB: '4.5em',
    fontxxl: '5em',
    fontxxxl: '5.8em',
    fontbig: '8em',

    navHeight:'5rem'
}
